import { render, staticRenderFns } from "./OpenBoxController.vue?vue&type=template&id=07b52f1e&scoped=true&"
import script from "./OpenBoxController.vue?vue&type=script&lang=js&"
export * from "./OpenBoxController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b52f1e",
  null
  
)

export default component.exports